module.exports = __webpack_public_path__ + "img/titleStar.00e232ff.png";